













import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import List from '@/views/document/section/List.vue';
import dokument from '@/store/modules/dokument';
import {ListSection} from '@/store/models';
import Toggle from '@/views/document/section/Toggle.vue';

@Component({components: {Toggle, List}})
export default class Yearend extends Vue {
  @Prop() readonly group!: any;

  @Watch('notesSection', {immediate: true, deep: true})
  onData1() {
    this.onData();
  }
  @Watch('covidSection', {immediate: true, deep: true})
  onData2() {
    this.onData();
  }

  onData() {
    if (this.group.Hidden !== this.hidden) {
      const g = {
        Id: this.group.Id,
        Kind: this.group.Kind,
        Type: this.group.Type,
        SubType: this.group.SubType,
        Children: this.group.Children,
        Hidden: this.hidden,
      };
      dokument.updateItem(g);
    }
  }

  get notesSection(): ListSection {
    return dokument.getItems(this.group.Id)[1] as ListSection;
  }

  get covidSection(): ListSection {
    return dokument.getItems(this.group.Id)[2] as ListSection;
  }

  get signingSection(): any {
    return dokument.getItems(this.group.Id)[3];
  }

  get hidden(): boolean {
    return this.notesSection.Hidden === true &&
        this.covidSection.Hidden === true &&
        this.signingSection.Hidden === true;
  }
}
